// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import * as Button$PrezzeeRibbon from "../Button/Button.bs.js";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Kontent$PrezzeeRibbon from "../Kontent/Kontent.bs.js";
import * as RegionList$PrezzeeRibbon from "../RegionList/RegionList.bs.js";
import * as ThemeContext$PrezzeeRibbon from "../../../context/ThemeContext/ThemeContext.bs.js";
import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";
import * as Theme__Typography$PrezzeeRibbon from "../../../theme/Theme__Typography.bs.js";

var wrapper = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.color(Theme__Color$PrezzeeRibbon.Personal.charcoal)]);

function heading(theme) {
  var match = theme.components;
  return BsCssJs$PrezzeeRibbon.merge([
              Theme__Typography$PrezzeeRibbon.Styles.h4,
              BsCssJs$PrezzeeRibbon.style([
                    BsCssJs$PrezzeeRibbon.marginBottom(BsCssJs$PrezzeeRibbon.px(10)),
                    BsCssJs$PrezzeeRibbon.color(match.regionPicker.headingColor)
                  ])
            ]);
}

function subText(theme) {
  var match = theme.components;
  return BsCssJs$PrezzeeRibbon.merge([
              Theme__Typography$PrezzeeRibbon.Styles.body,
              BsCssJs$PrezzeeRibbon.style([
                    BsCssJs$PrezzeeRibbon.marginBottom(BsCssJs$PrezzeeRibbon.px(5)),
                    BsCssJs$PrezzeeRibbon.color(match.regionPicker.descriptionColor)
                  ])
            ]);
}

var buttonWrapper = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.display("flex"),
      BsCssJs$PrezzeeRibbon.justifyContent("center"),
      BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.px(18))
    ]);

var saveButton = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.px(12)),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletOrDesktop, [BsCssJs$PrezzeeRibbon.important(BsCssJs$PrezzeeRibbon.minWidth(BsCssJs$PrezzeeRibbon.px(180)))]),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.mobile, [BsCssJs$PrezzeeRibbon.flexGrow(1)])
    ]);

var Styles = {
  wrapper: wrapper,
  heading: heading,
  subText: subText,
  buttonWrapper: buttonWrapper,
  saveButton: saveButton
};

function RegionPicker(props) {
  var onSave = props.onSave;
  var selected = props.selected;
  var strings = props.strings;
  var selected$1 = selected !== undefined ? selected : 0;
  var onSave$1 = onSave !== undefined ? onSave : (function (param) {
        
      });
  var match = React.useState(function () {
        return selected$1;
      });
  var setSelected = match[1];
  var _selected = match[0];
  var theme = ThemeContext$PrezzeeRibbon.useTheme(undefined);
  return JsxRuntime.jsx(Kontent$PrezzeeRibbon.Consumer.make, {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("h4", {
                            children: strings.heading,
                            className: heading(theme)
                          }),
                      JsxRuntime.jsx("p", {
                            children: strings.heading_subtext,
                            className: subText(theme)
                          }),
                      JsxRuntime.jsx(RegionList$PrezzeeRibbon.make, {
                            regions: props.regions,
                            selected: _selected,
                            onChange: (function (i) {
                                Curry._1(setSelected, (function (param) {
                                        return i;
                                      }));
                              })
                          }),
                      JsxRuntime.jsx(Button$PrezzeeRibbon.make, {
                            children: JsxRuntime.jsx("button", {
                                  children: strings.cta_button,
                                  className: saveButton,
                                  onClick: (function (param) {
                                      Curry._1(onSave$1, _selected);
                                    })
                                }),
                            className: buttonWrapper
                          })
                    ],
                    className: wrapper
                  })
            });
}

var make = RegionPicker;

export {
  Styles ,
  make ,
}
/* wrapper Not a pure module */
